import { REGIONS_KEYS } from '@/queries/regions/regions.keys';

export const SCHEDULE_KEYS = {
  main: 'schedule',
  cc: 'cc',
  cs: 'cs',
  s: 's',
  sLi: 'sLi',
  sHtLu: 'sHtLu',
  oms: 'oms',
  shifts: 'shifts',
  planningProcess: 'planningProcess',
  validation: 'validation',
  rules: 'rules',
  inputs: 'inputs',
  periodTimeGroupInputs: 'periodTimeGroupInputs', // CS specific
  periodRules: 'periodRules', // CS specific
  periodAtHubWeeklyInputs: 'periodAtHubWeeklyInputs', // CS specific
  periodDeductionShiftRules: 'periodDeductionShiftRules', // CS specific
  hrSystemConflicts: 'hrSystemConflicts',
};

export const getBaseScheduleKey = (type: string) => [`${SCHEDULE_KEYS.main}/${type}`] as const;

export const generateScheduleQueryKeys = (type: string) => {
  const BASE_KEY = getBaseScheduleKey(type);

  return {
    getShiftsKey: (...args: unknown[]) => [BASE_KEY, SCHEDULE_KEYS.shifts, ...args] as const,
    getRegionsKey: (...args: unknown[]) => [BASE_KEY, REGIONS_KEYS.main, ...args] as const,
    getScheduleKey: (...args: unknown[]) => [BASE_KEY, ...args] as const,
    getPlanningProcessKey: (...args: unknown[]) => [BASE_KEY, SCHEDULE_KEYS.planningProcess, ...args] as const,
    getValidationKey: (...args: unknown[]) => [BASE_KEY, SCHEDULE_KEYS.validation, ...args] as const,
    getRulesKey: (...args: unknown[]) => [BASE_KEY, SCHEDULE_KEYS.rules, ...args] as const,
    getInputsKey: (...args: unknown[]) => [BASE_KEY, SCHEDULE_KEYS.inputs, ...args] as const,
    getPeriodTimeGroupInputsKey: (...args: unknown[]) =>
      [BASE_KEY, SCHEDULE_KEYS.periodTimeGroupInputs, ...args] as const,
    getPeriodRulesKey: (...args: unknown[]) => [BASE_KEY, SCHEDULE_KEYS.periodRules, ...args] as const,
    getPeriodAtHubWeeklyInputsKey: (...args: unknown[]) =>
      [BASE_KEY, SCHEDULE_KEYS.periodAtHubWeeklyInputs, ...args] as const,
    getPeriodDeductionShiftRulesKey: (...args: unknown[]) =>
      [BASE_KEY, SCHEDULE_KEYS.periodDeductionShiftRules, ...args] as const,
    getHrSystemConflictsKey: (...args: unknown[]) => [BASE_KEY, SCHEDULE_KEYS.hrSystemConflicts, ...args] as const,
  };
};

export const scheduleQueryKeys = {
  cs: generateScheduleQueryKeys(SCHEDULE_KEYS.cs),
  s: generateScheduleQueryKeys(SCHEDULE_KEYS.s),
  sLi: generateScheduleQueryKeys(SCHEDULE_KEYS.sLi),
  sHtLu: generateScheduleQueryKeys(SCHEDULE_KEYS.sHtLu),
  cc: generateScheduleQueryKeys(SCHEDULE_KEYS.cc),
  oms: generateScheduleQueryKeys(SCHEDULE_KEYS.oms),
};
